import Home from './routes/Home.svelte'
import About from './routes/About.svelte'
import List from './routes/List.svelte'
import Map from './routes/Map.svelte'
import Timeline from './routes/Timeline.svelte'
import Scrape from './routes/Scrape.svelte'
import VideoStream from './routes/VideoStream.svelte'

export const routes = {
  '/': Home,
  '/about': About,
  '/timeline': Timeline,
  '/list/:id': List,
  '/map': Map,
  '/scrape': Scrape,
  '/video': VideoStream,
  //   '*': NotFound,
}
